import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AfDataType } from "utils/TableColumnData";
import Select from "react-select";
import handleWheel from "utils/handleOnWheel";
import { ErrorMessage } from "components/ErrorMessage";
import { UseMutateFunction, useMutation } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input } from "@heroui/react";
import UseToast from "utils/AfToast";
import { set } from "lodash";

const AddCollection: React.FC<{
  invoiceData: any;
  selectedInvoice: any;
  tableData: any;
}> = ({ invoiceData, selectedInvoice, tableData }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const getSelectedInvoice = () => {
    //selectedInvoice is array of tableData[i]->id
    const selectedInvoices = tableData.filter((invoice: any) => selectedInvoice.includes(invoice.id));
    return selectedInvoices;
  };

  const [totalAmount, setTotalAmount] = useState<any>(0);

  const [gstPercent, setGstPercent] = useState<any>(18);
  const [afterTdsAmount, setAfterTdsAmount] = useState<any>(0);
  const [totalBasic, setTotalBasic] = useState<any>(0);
  const [tdsValue, setTdsValue] = useState<any>(2);

  const [customerGstNo, setCustomerGstNo] = useState<string>("");
  const [remark, setRemark] = useState<string>("");
  const [payRcvDate, setPayRecvDate] = useState<string>("");

  const [customerId, setCustomerId] = useState<any>(null);

  const GET_SUMMARY = () => {
    console.log("Calculating summary... 1");
    const selectedInvoices = getSelectedInvoice();
    console.log("Selected Invoices: ", selectedInvoices, selectedInvoice.length);
    setCustomerId(selectedInvoices[0]?.customerId || null);

    let _totalBaseAmt = parseFloat(
      selectedInvoices
        .reduce((acc: number, curr: any) => acc + (Number(curr.total_d_tax || 0) + Number(curr.total_i_tax || 0)), 0)
        .toFixed(2)
    );
    const _totalGst = parseFloat((_totalBaseAmt * (parseInt(gstPercent) / 100)).toFixed(2));
    const _afterTdsAmount = parseFloat((_totalBaseAmt * ((100 - parseFloat(tdsValue || 0)) * 0.01) + _totalGst).toFixed(2));

    console.log("_totalBaseAmt:", _totalBaseAmt, "_totalGst:", _totalGst, "_afterTdsAmount:", _afterTdsAmount);

    setAfterTdsAmount(_afterTdsAmount);
    setTotalBasic(_totalBaseAmt);
    setTotalAmount(Number((_totalBaseAmt + _totalGst).toFixed(0)));
  };

  useEffect(() => {
    GET_SUMMARY();
  }, [selectedInvoice]);

  useEffect(() => {
    console.log("Calculating summary... 2");

    let _totalBaseAmt = parseFloat(totalBasic || 0);
    const _totalGst = parseFloat((_totalBaseAmt * (parseInt(gstPercent) / 100)).toFixed(2));
    const _afterTdsAmount = parseFloat((_totalBaseAmt * ((100 - parseFloat(tdsValue || 0)) * 0.01) + _totalGst).toFixed(2));

    setAfterTdsAmount(Math.round(_afterTdsAmount));
    setTotalAmount(Number((_totalBaseAmt + _totalGst).toFixed(0)));
  }, [totalBasic, tdsValue, gstPercent]);

  const doAddPayment = (onClose) => {
    if (payRcvDate == "" || !payRcvDate) {
      UseToast("Please select Pay Recv Date", "error");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want add " + afterTdsAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 }) + " as payment received!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, add it!",
    }).then((result) => {
      if (result.isConfirmed) {
        mutateAddPayment(
          {},
          {
            onSuccess: () => {
              onClose();
              setGstPercent(18);
              setTdsValue(2);
              setCustomerGstNo("");
              setRemark("");
              setPayRecvDate("");
            },
          }
        );
      }
    });
  };

  const { mutate: mutateAddPayment, isLoading } = useMutation(
    (data: any) =>
      CreateCommanWay({
        url: "/admin/collection/create",
        data: {
          customer: customerId,
          basicAmount: parseFloat(totalBasic),
          cgst: parseFloat(gstPercent),
          totalAmount: parseInt(afterTdsAmount),
          tds: parseFloat(tdsValue),
          status: "PAID",
          recvGstNo: customerGstNo || null,
          remark: remark || null,
          payRecvDate: payRcvDate,
          invoiceJson: {
            invoices: getSelectedInvoice().map((inv: any) => {
              return inv.id;
            }),
          },
        },
      }),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Payment Added Successfully", "success");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  return (
    <div>
      <Button onPress={onOpen} color="primary" className="font-semibold font-inter">
        Add Payment
      </Button>
      <Modal
        isDismissable={false}
        isKeyboardDismissDisabled={true}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        size="4xl"
        placement="center"
        scrollBehavior="inside"
        motionProps={{
          variants: {
            enter: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
            exit: { opacity: 0, scale: 0.95, transition: { duration: 0.3 } },
          },
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Add New Payment</ModalHeader>
              <ModalBody>
                <div className="flex gap-2">
                  <div className="bg-gray-100 p-2 rounded-md">
                    <table className="text-sm">
                      <tbody>
                        <tr>
                          <th className="border-x px-2">Inv No</th>
                          <th className="border-x px-2">Amount</th>
                          <th className="border-x px-2">CGST</th>
                          <th className="border-x px-2">SGST</th>
                          <th className="border-x px-2">IGST</th>
                        </tr>
                        {getSelectedInvoice().map((r: any, index: number) => (
                          <tr key={index}>
                            <td className="border-x px-2">{`${r._subbranch?.branch_code}${r.invoice_no}`}</td>
                            <td className="border-x px-2 text-right">
                              {Number(r.total_value).toLocaleString("en-IN", { maximumFractionDigits: 0 })}
                            </td>
                            <td className="border-x px-2 text-right">{Number(r.total_d_tax * 0.09).toFixed(2)}</td>
                            <td className="border-x px-2 text-right">{Number(r.total_d_tax * 0.09).toFixed(2)}</td>
                            <td className="border-x px-2 text-right">{Number(r.total_i_tax * 0.18).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className="border-x px-2">Total</th>
                          <th className="border-x px-2 text-right">
                            {getSelectedInvoice()
                              .reduce((acc: number, curr: any) => acc + Number(curr.total_value), 0)
                              .toLocaleString("en-IN", { maximumFractionDigits: 0 })}
                          </th>
                          <th className="border-x px-2 text-right">
                            {getSelectedInvoice()
                              .reduce((acc: number, curr: any) => acc + Number(curr.total_d_tax * 0.09), 0)
                              .toFixed(2)}
                          </th>
                          <th className="border-x px-2 text-right">
                            {getSelectedInvoice()
                              .reduce((acc: number, curr: any) => acc + Number(curr.total_d_tax * 0.09), 0)
                              .toFixed(2)}
                          </th>
                          <th className="border-x px-2 text-right">
                            {getSelectedInvoice()
                              .reduce((acc: number, curr: any) => acc + Number(curr.total_i_tax * 0.18), 0)
                              .toFixed(2)}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="[&_input]:border-none [&_input]:px-0 flex flex-col gap-2 bg-gray-100 p-2 rounded-md">
                    <div className="grid grid-cols-2 font-RobotoCondensed">
                      <Input
                        label="Base Amount"
                        variant="bordered"
                        className="border-none grid grid-cols-[1fr,2fr]"
                        labelPlacement="outside-left"
                        value={totalBasic + ""}
                        onChange={(e) => {
                          setTotalBasic(e.target.value);
                        }}
                      />

                      <Input
                        label="GST (%)"
                        variant="bordered"
                        className="border-none grid grid-cols-[1fr,2fr] text-right"
                        labelPlacement="outside-left"
                        value={gstPercent}
                        onChange={(e) => {
                          setGstPercent(e.target.value);
                        }}
                      />
                    </div>

                    <div className="grid grid-cols-2">
                      <Input
                        label="Invoice Amount"
                        variant="bordered"
                        className="border-none grid grid-cols-[1fr,2fr]"
                        labelPlacement="outside-left"
                        value={totalAmount + ""}
                        disabled
                      />
                      <Input
                        label="TDS (%)"
                        variant="bordered"
                        className="border-none grid grid-cols-[1fr,2fr] text-right"
                        labelPlacement="outside-left"
                        value={tdsValue}
                        onChange={(e) => {
                          setTdsValue(e.target.value);
                        }}
                      />
                    </div>

                    {/* recvGstNo, remark, refNo, nextFollowDate, bankMode */}

                    <div className="grid grid-cols-2">
                      <div className="px-2 py-1 bg-blue-600/10 rounded-md flex flex-col items-center justify-center">
                        <p className="text-blue-600 font-semibold font-RobotoCondensed">
                          Amt Rcvd: {afterTdsAmount.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                        </p>
                      </div>
                      <Input
                        label="GST No"
                        variant="bordered"
                        className="border-none grid grid-cols-[1fr,2fr] text-right"
                        labelPlacement="outside-left"
                        value={customerGstNo}
                        onChange={(e) => {
                          setCustomerGstNo(e.target.value);
                        }}
                      />
                    </div>

                    <Input
                      label="Pay Recv Date"
                      type="date"
                      variant="bordered"
                      className="border-none  grid grid-cols-[1fr,2fr]"
                      labelPlacement="outside-left"
                      value={payRcvDate}
                      onChange={(e) => {
                        setPayRecvDate(e.target.value);
                      }}
                    />

                    <Input
                      label="Remark"
                      variant="bordered"
                      className="border-none grid grid-cols-[1fr,2fr]"
                      labelPlacement="outside-left"
                      value={remark}
                      onChange={(e) => {
                        setRemark(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button
                  color="primary"
                  onPress={() => {
                    doAddPayment(onClose);
                  }}
                  isLoading={isLoading}
                >
                  Action
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};

export { AddCollection };
